import React, { createContext, useContext } from "react"

const FeatureFlagContext = createContext({})

export const FeatureFlagProvider = ({ children, flags }) => (
  <FeatureFlagContext.Provider value={flags}>{children}</FeatureFlagContext.Provider>
)

export const useFeatureFlags = () => useContext(FeatureFlagContext)
